import { useMemo, forwardRef } from "react";
import { Color, MeshStandardMaterial, Shape } from "three";
import { degToRad } from "three/src/math/MathUtils";
import * as THREE from "three";

const RoundedPlaneGeometry = forwardRef(
  ({ radius = 0.25, lenght = 2, width = 1, height = 0.25, curveSegments = 32, renderOrder = -1, ...props }, ref) => {
    const planeMaterial = useMemo(() => {
      var mat = new MeshStandardMaterial();
      mat.color = new Color("#4f7660");
      mat.metalness = 0.1;
      mat.roughness = 0.4;
      mat.transparent = true;

      return mat;
    }, []);

    const shape = useMemo(() => {
      const shape = new Shape();
      const flatSideLength = lenght - 2 * radius;
      const halfSideLength = flatSideLength / 2;
      const flatSideWidth = width - 2 * radius;
      const halfSideWidth = flatSideWidth / 2;

      shape.moveTo(-lenght / 2, halfSideWidth);
      // shape.lineTo(-halfSideLength, lenght / 2);
      shape.absarc(-halfSideLength, halfSideWidth, radius, degToRad(180), degToRad(90), true);
      shape.lineTo(halfSideLength, width / 2);
      shape.absarc(halfSideLength, halfSideWidth, radius, degToRad(90), degToRad(0), true);
      shape.lineTo(lenght / 2, -halfSideWidth);
      shape.absarc(halfSideLength, -halfSideWidth, radius, degToRad(0), degToRad(270), true);
      shape.lineTo(-halfSideLength, -width / 2);
      shape.absarc(-halfSideLength, -halfSideWidth, radius, degToRad(270), degToRad(180), true);

      shape.closePath();

      return shape;
    }, [radius, lenght, width, height, curveSegments]);

    return (
      <mesh rotation={[degToRad(90), degToRad(180), 0]} material={planeMaterial} renderOrder={renderOrder} {...props}>
        <shapeGeometry side={THREE.DoubleSide} center={true} args={[shape, curveSegments]} />
      </mesh>
    );
  },
);

export default RoundedPlaneGeometry;
